import { createGlobalStyle } from 'styled-components';

export const AntCardStyles = createGlobalStyle`
.ant-card {
  color: inherit;
}`;
